export const routes = {
  signin: '/login',
  home: '/',
}
